import { STEPS } from "@/data/turboData";

const HowItWorks = () => (
  <section className="relative py-20 md:py-28 bg-white border-y border-[var(--tt-line)]">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="max-w-2xl">
        <div className="text-xs uppercase tracking-[0.2em] text-[var(--tt-accent)] font-semibold">
          How it works
        </div>
        <h2 className="font-display text-4xl md:text-5xl font-bold text-[var(--tt-navy)] mt-3 leading-[1.05]">
          From quote to delivered, in four simple steps.
        </h2>
      </div>

      <ol className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-3">
        {STEPS.map((s, i) => (
          <li
            key={s.n}
            className="relative pl-0 lg:pr-6"
          >
            <div className="flex items-center gap-4 lg:flex-col lg:items-start">
              <div className="font-display text-5xl lg:text-7xl font-bold text-[var(--tt-accent)]/25 leading-none">
                {s.n}
              </div>
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-7 left-24 right-0 h-px bg-gradient-to-r from-[var(--tt-line)] to-transparent" />
              )}
            </div>
            <h3 className="font-display text-xl font-bold text-[var(--tt-navy)] mt-4">
              {s.title}
            </h3>
            <p className="mt-2 text-sm text-[var(--tt-ink-soft)] leading-relaxed pr-2">
              {s.body}
            </p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default HowItWorks;
